module.exports = __webpack_public_path__ + "ff25950.webp";